import MarketingShell, { LegalSection } from "@/components/MarketingShell";

export default function Privacy() {
  return (
    <MarketingShell eyebrow="/ Privacy" title="Privacy Policy" updated="Last updated: June 2026">
      <p className="text-lg text-foreground">
        This Privacy Policy explains what data AI Visibility OS collects, how we use it, and the choices
        you have. We keep it short and human.
      </p>

      <LegalSection heading="1. Information we collect">
        <p>
          <b>Account data:</b> your email, business name and website URL when you sign up.
          <br />
          <b>Audit data:</b> publicly accessible content of the websites you submit for analysis
          (homepage, robots.txt, sitemap and similar public resources).
          <br />
          <b>Usage data:</b> basic analytics about how you interact with the dashboard so we can improve it.
        </p>
      </LegalSection>

      <LegalSection heading="2. What we do NOT collect">
        <p>
          We never ask for or store your CMS, hosting or social-media passwords. We only crawl pages that
          are publicly visible to any visitor. Any third-party API keys you connect (e.g. Google, Bing)
          are stored securely server-side and are never exposed to your browser or other users.
        </p>
      </LegalSection>

      <LegalSection heading="3. How we use your data">
        <p>
          To run audits, calculate your AI Visibility Score, generate recommendations and fixes, send
          you product and account emails, and provide support. We do not sell your personal data.
        </p>
      </LegalSection>

      <LegalSection heading="4. Third-party services">
        <p>
          We use trusted providers to operate the service, including AI model providers for generating
          explanations and a payment processor for subscriptions. These providers process data only as
          needed to deliver their function.
        </p>
      </LegalSection>

      <LegalSection heading="5. Data retention &amp; your rights">
        <p>
          You can request export or deletion of your account and audit data at any time. We retain data
          only as long as needed to provide the service or comply with legal obligations.
        </p>
      </LegalSection>

      <LegalSection heading="6. Contact">
        <p>
          For privacy requests, email
          {" "}<a href="mailto:privacy@aivisibilityos.com" className="text-intl underline underline-offset-4">privacy@aivisibilityos.com</a>.
        </p>
      </LegalSection>
    </MarketingShell>
  );
}
